import { Component, OnInit } from "@angular/core";
import * as moment from "moment";
import { NgxSpinnerService } from "ngx-spinner";
import { AppService } from "src/app/core/services/app.service";
import { FocuslinkService } from "src/app/core/services/focuslink.service";
import { LocalDataStoreService } from "src/app/core/services/local-data-store.service";
import { UserService } from "src/app/core/services/user.service";
import { OOVenueService } from "src/app/core/services/venue-service";
import { Check } from "src/app/shared/models/check";
import { CheckDto } from "src/app/shared/models/check-dto";
import { LicenseTypes } from "src/app/shared/models/enums/license-types";

@Component({
	selector: "app-dashboard",
	templateUrl: "./dashboard.component.html",
	styleUrls: ["../commandcenter.scss"],
})
export class DashboardComponent implements OnInit {
	checks: Check[];
	checkSelected: CheckDto;

	kitchenPerformance: boolean = false;

	loaded: boolean = false;

	//kitchen gauge

	moment: any = moment;

	orders = {
		inStoreCount: 0,
		onlineCount: 0,
		inStoreRevenue: 0,
		onlineRevenue: 0,
		newCustomers: 0,
		existingCustomers: 0,
	};

	// venueKey: number;
	// venueInfo: Store;

	constructor(
		public app: AppService,
		private focuslink: FocuslinkService,
		private localStorage: LocalDataStoreService,
		private spinner: NgxSpinnerService,
		public userService: UserService,
		public venueService: OOVenueService
	) {}

	ngOnInit(): void {
		this.app.loading(true);
		this.venueService.licenses.subscribe((data) => {
			if (data?.length > 0) {
				if (data.some((i) => i.type === LicenseTypes.KitchenDevice)) {
					this.kitchenPerformance = true;
				}
			}
		});

		this.venueService.subscriptionOOvenue.subscribe((data) => {
			if (data?.venueKey) {
				this.checksGet(data.venueKey);
				// this.guestSurveyGet(data.venueKey);
			}
		});
		this.init();
	}

	async init() {
		this.app.loading(false);
	}

	async checksGet(venueKey) {
		this.orders.onlineCount = 0;
		this.orders.onlineRevenue = 0;
		this.orders.inStoreCount = 0;
		this.orders.inStoreRevenue = 0;
		const resp = await this.focuslink.getChecks(venueKey, moment().format("YYYY-MM-DD"), moment().format("YYYY-MM-DD"), true);
		const checks = resp.map((i) => {
			const check = new Check(i);
			if (!check.queueDateTime) {
				this.orders.inStoreCount += 1;
				this.orders.inStoreRevenue += check.subtotal;
			} else {
				this.orders.onlineCount += 1;
				this.orders.onlineRevenue += check.subtotal;
			}
			return check;
		});
		this.checks = checks.sort((a, b) => (moment(a.timeOpened).unix() > moment(b.timeOpened).unix() ? 1 : -1));
		this.loaded = true;
	}

	async checkGet(venueKey: number, checkKey: string) {
		const resp = await this.focuslink.getCheck(venueKey, checkKey);
		this.checkSelected = new CheckDto(resp);
	}
}
